module.exports = __webpack_public_path__ + "static/assets/73b3649625bed526e496a41860dc8400.gif";